var images = Array.from(document.querySelectorAll('.carousel-image'));
var thumbnails = Array.from(document.querySelectorAll('.carousel-thumbnail'));
var counter = document.querySelector('.carousel-counter');
var prevButton = document.querySelector('.carousel-button-prev');
var nextButton = document.querySelector('.carousel-button-next');
var counterText = document.querySelector('#carousel-counter-text');

function updateCarousel(index) {
    images.forEach(function(image) {
        image.classList.remove('active');
    });
    thumbnails.forEach(function(thumbnail) {
        thumbnail.classList.remove('active');
    });
    images[index].classList.add('active');
    thumbnails[index].classList.add('active');
    counterText.textContent = (index + 1) + '/' + images.length;
}

thumbnails.forEach(function(thumbnail, index) {
    thumbnail.addEventListener('click', function() {
        updateCarousel(index);
    });
});

prevButton.addEventListener('click', function() {
    var currentIndex = images.findIndex(function(image) {
        return image.classList.contains('active');
    });
    var prevIndex = (currentIndex - 1 + images.length) % images.length;
    updateCarousel(prevIndex);
});

nextButton.addEventListener('click', function() {
    var currentIndex = images.findIndex(function(image) {
        return image.classList.contains('active');
    });
    var nextIndex = (currentIndex + 1) % images.length;
    updateCarousel(nextIndex);
});

updateCarousel(0);